// URL del backend API
// Para desarrollo local: usa Railway directamente
// Para producción en Cloudflare Pages: se configura con variable de entorno REACT_APP_API_URL
export const apiUrl = process.env.REACT_APP_API_URL || "https://api.logemp.com/api";
export const informativeUrl = "https://app.logemp.com/";

// Debug: Log para verificar qué URL se está usando
console.log('API URL configurada:', apiUrl);
console.log('REACT_APP_API_URL desde env:', process.env.REACT_APP_API_URL);
